import { render, staticRenderFns } from "./PdpAddToCartStatus.vue?vue&type=template&id=37d90ae0&"
import script from "./PdpAddToCartStatus.vue?vue&type=script&lang=js&"
export * from "./PdpAddToCartStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports